export default __webpack_public_path__ + "static/media/7.a3305bef.jpeg";